// extracted by mini-css-extract-plugin
export default {"controlsList":"style_controlsList__p0kyQ","column":"style_column__BLZ2Y","wrap":"style_wrap__5AMwx"};